export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";